import useDevelop from './useDevelop';

function useProduction() {
	const {isDevelop, loading} = useDevelop();

	return {isProduction: !isDevelop, loading};
}

export default useProduction;
